<!-- begin login -->
<div class="login login-with-news-feed" style="min-height: 100vh">



  <!-- begin news-feed -->
  <div class="news-feed">
    <div class="news-image" style="background-image: url(../assets/img/login-bg/login-bg.png)"></div>

    <div class="news-caption">
      <h4 class="caption-title">{{ 'login_caption_title' | localise }}</h4>
      <p>
        {{ 'login_caption_subtitle' | localise }}
      </p>
    </div>
  </div>
  <!-- end news-feed -->
  <!-- begin right-content -->
  <div class="right-content">

    <div class="d-flex p-20 flex-row-reverse">
      <app-language-dropdown></app-language-dropdown>
    </div>


    <!-- begin login-header -->
    <div class="login-header">


      <div class="brand">
        <img src="../assets/img/logo/origami.png" height="60px" style="margin-right: 10px" />
        {{ 'login_main_logo' | localise }}
      </div>
      <div class="icon">
        <i class="fa fa-sign-in"></i>
      </div>
    </div>

    <!-- end login-header -->
    <!-- begin login-content -->
    <div class="login-content">

      <h1>{{ 'login_main_title' | localise }}</h1>
      <p>{{ 'login_main_subtitle' | localise }}</p>

      <form [formGroup]="loginForm.Group" novalidate class="margin-bottom-0" data-parsley-validate="true">
        <h2 class="register-header">
          {{ 'login_main_connect' | localise }}
        </h2>
        <app-form-input [parameters]="loginForm.GetInputElement('email')"></app-form-input>
        <app-form-input [parameters]="loginForm.GetInputElement('password')"></app-form-input>
        <app-form-general-error [submitForm]="loginForm"></app-form-general-error>
        <!--<div class="checkbox checkbox-css m-b-30">
          <input type="checkbox" id="remember_me_checkbox" value="" />
          <label for="remember_me_checkbox">
          Rester connecté
          </label>
        </div>
        -->
        <div class="login-buttons">
          <button (click)='loginForm.Submit()' [disabled]="!loginForm.Valid"
            class="btn btn-login-connect-bleu btn-block btn-lg">{{ 'login_main_button' | localise }}</button>
        </div>
        <div class="m-t-20 p-b-20 text-inverse">
          <a [routerLink]="['..', 'inscription']"
            class="text-success">{{ 'login_main_to_signup' | localise }}</a>
        </div>
        <!-- <div class="m-t-20 p-b-20 text-inverse">
          <a [routerLink]="['..', 'inscription']" class="text-success">{{ 'login_main_to_signup' | localise }}</a>
        </div> -->
        <div class="m-b-20 p-b-20 text-inverse">
          <a [routerLink]="['..', 'resetPassword']" class="text-primary">{{ 'login_forgot_password' | localise }}</a>
        </div>


        <hr />
        <p class="text-center text-grey-darker">
          {{ 'login_main_copyright' | localise }}
        </p>
      </form>
    </div>
    <!-- end login-content -->
  </div>
  <!-- end right-container -->
  <app-wait [show]='busy'></app-wait>
</div>
<!-- end login -->